const GENDERS = {
    male: 'Male',
    female: 'Female',
    other: 'Other',
};

export default GENDERS;

export const TranslateGenders = t =>
    Object.keys(GENDERS).reduce(
        (acc, key) => ({
            ...acc,
            [key]: t(`genders.${key}`),
        }),
        {}
    );
